import { render, staticRenderFns } from "./special.vue?vue&type=template&id=bf7cbf96&scoped=true"
import script from "./special.vue?vue&type=script&lang=js"
export * from "./special.vue?vue&type=script&lang=js"
import style0 from "./special.vue?vue&type=style&index=0&id=bf7cbf96&prod&scoped=true&lang=less"
import style1 from "./special.vue?vue&type=style&index=1&id=bf7cbf96&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7cbf96",
  null
  
)

export default component.exports